const nonAlphaOperatorAliases = {
  "=": "===",
  "<>": "!==",
}

const alphaOperatorAliases = {
  OR: "||",
  AND: "&&",
}

export { nonAlphaOperatorAliases, alphaOperatorAliases }
